import mainRoutes from "./main/router";
import analyticsRoutes from "./analytics/router";
import applicationRoutes from "./applications/router";
import authRoutes from "./auth/router";
import autoparkRoutes from "./autopark/router";
import counterpartiesRoutes from "./counterparties/router";
import documentRoutes from "./document/router";
import fuelRoutes from "./fuel/router";
import geographyRoutes from "./geography/router";
import receivedRoutes from "./received/router";
import guideRoutes from "./guide/router";
import purchasesRoutes from "./purchases/router";
import arrivalsRoutes from "./arrivals/router";

export const moduleRoutes = [
  ...mainRoutes,
  ...applicationRoutes,
  ...analyticsRoutes,
  ...authRoutes,
  ...autoparkRoutes,
  ...counterpartiesRoutes,
  ...documentRoutes,
  ...fuelRoutes,
  ...geographyRoutes,
  ...receivedRoutes,
  ...guideRoutes,
  ...purchasesRoutes,
  ...arrivalsRoutes,
];
